import { PageLoading } from "#components/ui/PageLoading.tsx";
import { ChannelsDetails } from "#features/channels/components/ChannelsDetails.tsx";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { useSidePanelStore } from "#stores/useSidePanelStore.ts";
import { Button, Div, Flex, Grid, Heading, type GridProps } from "@hopper-ui/components";
import { DismissIcon } from "@hopper-ui/icons";
import { Suspense } from "react";

export const ChannelsSidePanel = ({ ...rest }: Partial<GridProps>) => {
    const { tShared } = useSharedTranslation();
    const closeSidePanel = useSidePanelStore(state => state.closeSidePanel);

    return (
        <Grid
            templateRows={["auto", "1fr"]}
            height="100%"
            {...rest}
        >
            <Div
                padding="inset-md"
                borderBottom="neutral-weakest"
                className="wai-side-panel-item"
                style={{ "--wai-side-panel-item-delay": "0ms" } as React.CSSProperties}
            >
                <Flex
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Heading>
                        {tShared("knowledgeSources")}
                    </Heading>
                    <Button
                        variant="ghost-secondary"
                        aria-label={tShared("close")}
                        onPress={closeSidePanel}
                    >
                        <DismissIcon />
                    </Button>
                </Flex>
            </Div>
            <Suspense fallback={<PageLoading />}>
                <Div overflowY="auto">
                    <ChannelsDetails />
                </Div>
            </Suspense>
        </Grid>
    );
};
